import _ from 'lodash';

import {usePage} from '@inertiajs/vue3';
import axios from 'axios';

window._ = _;

window.axios = axios;

window.axios.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest';


export const jsonTranslator = (key, replacements = {}) => {
    const translations = usePage().props.translations || {}; // Get JSON translations from Laravel
    let translation = translations[key] || key; // Fallback to key if not found

    // Replace placeholders (e.g., ":name" -> "John")
    Object.keys(replacements).forEach((placeholder) => {
        translation = translation.replace(`:${placeholder}`, replacements[placeholder]);
    });

    return translation;
};